import { Component, Vue, Inject } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

import { dictionary } from '@/helpers/dictionnary'

@Component
export default class Form extends Vue {
  fields: any
  errors: any
  formLoading: boolean = false

  @Getter('locale', { namespace: 'user' }) locale

  fieldMessage(field) {
    return this.errors.has(field) ? this.errors.collect(field) : null
  }

  fieldType(field) {
    if (!this.fields[field]) {
      return
    }
    if (this.errors.has(field) && this.fields[field].touched ) {
      return 'is-danger'
    }
    if (this.fields[field].valid && this.fields[field].touched) {
      return 'is-success'
    }
  }

  get formValid(): boolean {
    return Object.keys(this.fields).every((field) => {
      return(this.fields[field] && this.fields[field].valid)
    })
  }

  get formUpdated(): boolean {
    return Object.keys(this.fields).some((key) => {
      return this.fields[key].dirty
    })
  }

  created() {
    this.$validator.localize(this.locale, dictionary[this.locale])
    // @ts-ignore
    this.$validator.extend('verify_password', {
      getMessage: (field) => this.$t('password.verify.notice'),
      validate: (value) => new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])').test(value)
    })
  }

  async formCanBeSubmitted() {
    if (!this.formValid) {
      return false
    }
    return await this.$validator.validateAll()
  }
}
